import React, { useEffect, useState } from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Button, Grid } from "@mui/material";

import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { openDialog } from "state/slices/DialogSlice";
import { useTypedDispatch, useTypedSelector } from "hooks/store";

import "./ChangePatient.scss";

import PatientPositionItem from "../PatientPosition/PatientPositionItem";

import Switch from "@mui/material/Switch";

const DialogSaveModelContent = (): JSX.Element => {
    const dispatch = useTypedDispatch();
    const type = useTypedSelector((store) => store.Dialog.type);

    const handleDialogClose = (): void => {
        dispatch(openDialog({ isDialogOpen: false, type }));
    };

    const availablePositions = useTypedSelector((store) => store.Scene.availablePatientPosition);

    const [gender, setGender] = useState<boolean>(true);
    const [filteredResult, setFilteredResult] = useState([{}]);

    useEffect(() => {
        const pos = availablePositions.filter((data) => {
            if (gender === true && data.gender === "female") {
                return data;
            } else if (gender === false && data.gender === "male") {
                return data;
            }
        });

        setFilteredResult(pos);
    }, [gender]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setGender(event.target.checked);
    };

    return (
        <>
            <DialogActions className="cmrDialogActionContainer">
                <Button
                    startIcon={<CloseOutlinedIcon />}
                    fullWidth
                    onClick={handleDialogClose}
                    className="btn grayRoundedButton"
                >
                    Cancel
                </Button>
            </DialogActions>
            <DialogContent>
                <section>
                    <Grid container>
                        <Grid item xs={12} className="heading">
                            <h2 style={{ marginBottom: "30px" }}>Select patient&apos;s position</h2>
                        </Grid>
                        <Grid item xs={12}>
                            <div className="toggle-cont">
                                <span>Male</span>
                                <Switch
                                    checked={gender}
                                    onChange={handleChange}
                                    inputProps={{ "aria-label": "controlled" }}
                                />
                                <span>Female</span>
                            </div>
                        </Grid>
                    </Grid>
                    <div className="patient-container">
                        <Grid container spacing={2}>
                            {filteredResult.map((position, i) => {
                                return (
                                    <>
                                        <Grid item xs={4} key={i}>
                                            <PatientPositionItem item={position} />
                                        </Grid>
                                    </>
                                );
                            })}
                        </Grid>
                    </div>
                </section>
            </DialogContent>
        </>
    );
};

export default DialogSaveModelContent;
